import { Component, OnInit , ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { SurveyentryService } from "../../surveyentry/shared/surveyentry.service";

@Component({
  selector: 'app-surveyentrylist',
  templateUrl: './surveyentrylist.component.html',
  styleUrls: ['./surveyentrylist.component.css']
})
export class SurveyentrylistComponent implements OnInit {

  displayedColumns: string[] = ['SurveyNo', 'Survey Date', 'Enquiry No.', 'Enquiry Date', 'Place','Staff', 'Remarks', 'New'];
  surveyEntryList : [''];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router,
    private surveyentrylistService: SurveyentryService ) {
       this.dataSource.paginator = this.paginator
     }

  ngOnInit() {
    this.getSurveyEntryList();
  }

  getSurveyEntryList(){
    this.surveyentrylistService.FetchSurveyEntryList().subscribe(data => {
      // this.surveyEntryList = data;
      this.dataSource.data = data;
   })
  }

  AddNew(surveyNo: number) { 
    this.router.navigate(['/surveyentry', { Id: 101, Id1: 102 }]);;
  }

  Edit(obj) {
    // this.router.navigate(['/suveryentry', obj.SurveyNo]);
    this.router.navigate(['/surveyentry', { Id: obj.SurveyNo, Id1: 202 }]);
  }
  
}

